import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { XStackContainer } from "../../Containers";
import { ObjectDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { LineChartFormControl } from "../Web/LineChartFormControl";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: LineChartFormControl } {
    let ui = new FormConfiguration();
    let dataDef = ui.getInputDefinition();

    const chartDataDef = new ObjectDataDefinition("invoiceByMonth");
    chartDataDef.list = true;
    const labelDef = new StringDataDefinition("label");
    const valueDef = new NumberDataDefinition("value");
    chartDataDef.fields.push(labelDef);
    chartDataDef.fields.push(valueDef);
    dataDef.fields.push(chartDataDef);

    const values = [
        {
            label: "Jan",
            value: "1500",
        },
        {
            label: "Feb",
            value: "1250",
        },
        {
            label: "Mar",
            value: "1600",
        },
        {
            label: "Apr",
            value: "1400",
        },
        {
            label: "May",
            value: "1940",
        },
        {
            label: "Jun",
            value: "1150",
        },
        {
            label: "Jul",
            value: "1600",
        },
    ];

    dataDef.value["invoiceByMonth"] = values;

    ui.inputData = dataDef;

    let container = new XStackContainer();
    const chart = new LineChartFormControl();
    container.add(chart);
    ui.add(container);

    return { form: ui, control: chart };
}

export const LineChartStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Chart",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Line Chart";
            ui.control.chartType = "LineChart";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Chart",
        "Line Type",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.chartType = "BarChart";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Chart",
        "Bar Type",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.chartType = "BarChart";
            ui.control.showLegend = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Chart",
        "Bar Type with Legend",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.chartType = "BarChart";
            ui.control.showLegend = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Chart",
        "Bar Type with Legend",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.chartType = "BarChart";
            ui.control.show3D = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Chart",
        "Bar Type (3d)",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.chartType = "BarChart";
            ui.control.cursor = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Chart",
        "Bar Type (with cursor)",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.chartType = "BarChart";
            ui.control.exportable = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Chart",
        "Bar Type (exportable)",
    ),
];
